import { Column } from '@ant-design/plots';
import React from 'react';
import { Props } from './types';
import { Datum } from '@antv/g2plot';

const DemoColumn: React.FC<Props> = (props) => {
  const data =
    props.data?.length > 0
      ? props.data
      : [{ client: 'Sem dados', type: 'Sem dados', value: 0, name: 'Sem dados' }];

  const config = {
    data,
    isStack: true,
    xField: 'name',
    yField: 'value',
    colorField: 'type',
    color: ['#FAD337', '#7FD8AB'],
    seriesField: 'type',
    tooltip: {
      formatter: (datum: Datum) => {
        return {
          name: `<span style="font-size: 16px">${datum.type}</span>`,
          value: `<span style="font-size: 18px">${datum.value}</span>`,
        };
      },
    },
    label: {
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
    legend: {
      layout: undefined,
      position: undefined,
      custom: true,
      items: [
        {
          value: '',
          name: '',
          marker: {
            style: {
              fill: 'transparent',
              r: 0,
            },
          },
        },
        {
          value: '',
          name: '',
          marker: {
            style: {
              fill: 'transparent',
              r: 0,
            },
          },
        },
      ],
    },
  };

  return <Column {...config} />;
};

export default DemoColumn;
